<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                        <v-flex v-if="!Update_Details">Add Curriculam</v-flex>
                        <v-flex v-else>Update Curriculam</v-flex>
                        <v-btn icon @click="CloseDialog">
                            <v-icon color="text--secondary">close</v-icon>
                        </v-btn>
                    </v-card-title>
                <v-card-text v-if="!Update_Details">
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>
                             <v-select item-value='_id' item-text='name' return-object v-model="SelectedMiniProject" :items="GetProjectsList" label="Select Project">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Project_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Project_Title }}    
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Section Title" v-model="Section_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Section Time (Eg : 01:30 )" v-model="Section_Time"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-weight:bold;padding-bottom: 10px;">Section Description :</v-flex>
                            <vue-editor v-model="Section_Description"></vue-editor>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else>
                     <v-flex wrap style="padding: 10px;">
                        <v-flex>
                            Project Title   : {{ Project_Name }}
                        </v-flex>
                        <v-flex>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedSection" :items="Sections" @change="SelectSection" label="Select Section">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Section_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Section_Title }}    
                                </template>
                            </v-select>
                        </v-flex>
                         <v-flex>
                            <v-text-field label="Section Title" v-model="Section_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Section Time (Eg : 01:30 )" v-model="Section_Time"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-weight:bold;padding-bottom: 10px;">Section Description :</v-flex>
                            <vue-editor v-model="Section_Description"></vue-editor>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details" @click="SubmitCurriculam">Submit Curriculam</v-btn>
                        <v-btn color="success" v-else @click="UpdateCurriculam">Update Curriculam</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            SelectedMiniProject     : {},
            Update_Details          : false,
            Section_Description     : "",
            Section_Title           : "",
            Section_Time            : "",
            Current_Course_Details  : {},
            MiniProjects            : [],
            SelectedSection         : {},
            Section_Id              : "",
            Project_Id              : "",
            Project_Name            : "",
            Sections                : [],
        }
    },
    computed:{
        GetProjectsList(){
            
            return this.MiniProjects
        },
        GetSectionList(){

            return  this.$store.getters.GetCourseSection
        }
    },
    methods:{
        CloseDialog(){
            this.$emit('close')
        },
        GetDetailstoUpdate(Project){
            
            this.GetMiniProjectList()
                .then(response =>{
                    
                    this.Update_Details = true
                    this.Project_Id     = Project['_id']
                    this.Project_Name   = Project['Project_Title']
                    this.Sections       = Project['Project_Curriculam']
                })
                .catch(error =>{

                    console.log(error)
                })
        },
        SelectSection(){
            
            this.Section_Id          = this.SelectedSection['Section_Id']
            this.Section_Title       = this.SelectedSection['Section_Title']
            this.Section_Time        = this.SelectedSection['Section_Time']
            this.Section_Description = this.SelectedSection['Section_Description']
        },
        SubmitCurriculam(){

            let Section = {}
            Section["Project_Id"]          = this.GetProjectsList.find(x => x["Project_Title"] == this.SelectedMiniProject['Project_Title'])["_id"]
            Section['Section_Title']       = this.Section_Title
            Section["Section_Description"] = this.Section_Description
            Section["Section_Time"]        = this.Section_Time
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/addcurriculam`,Section)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualProjects',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Added Section Successfully","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Add Section","Color":"red","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedCourse          = ""
            this.SelectedMiniProject     = ""
            this.Section_Title           = ''
            this.Section_Description     = ""
            this.Section_Time            = ""
        },
        GetMiniProjectList(){

            return new Promise((resolve,reject) =>{

                
                this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/getminiprojects`,{})
                            .then(response =>{
    
                                this.MiniProjects = response["data"]["response"]
                                resolve(true)
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                                reject(err)
                            })
            })
        },
        UpdateCurriculam(){
            
            let Section = {}
            Section["Project_Id"]          = this.Project_Id
            Section['Section_Id']          = this.Section_Id
            Section['Section_Title']       = this.Section_Title
            Section["Section_Description"] = this.Section_Description
            Section["Section_Time"]        = this.Section_Time
        
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/updatecurriculam`,Section)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualProjects',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Section","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Section","Color":"red","Close": false });
                        })

        }
    }
}
</script>
<style scoped>

</style>